import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';

import { ISharedResourcesAvailabilityResponse } from 'components/widgets/Gantt/components/ganttChart.types';

export const useSharedResourcesAvailability = (params, endpoint?: string) => {
    return useQuery<ISharedResourcesAvailabilityResponse, QueryError>(
        ['sharedResourcesAvailability', params],
        () => queryFn(params, endpoint),
        {
            enabled: Boolean(params.lastMetaDataId),
        },
    );
};
